import React from 'react';
import { Section } from '@antonpodolsky/design-system/regions/section/section';
import { Grid } from '@antonpodolsky/design-system/layout/grid/grid';
import { Show } from '@antonpodolsky/design-system/layout/show/show';
import { LazyImage } from '@antonpodolsky/design-system/media/lazy-image/lazy-image';
import { cloudinaryImage } from '../../lib/cloudinary';

const SCREENSHOTS = [
  {
    src: cloudinaryImage(
      'v1752425594/exify-overlay-example-default_bdke4w.png'
    ),
    alt: 'Default overlay example',
    width: 1000,
    height: 562,
  },
  {
    src: cloudinaryImage(
      'v1752425593/exify-overlay-example-compact_vbddfo.png'
    ),
    alt: 'Compact overlay example',
    width: 1000,
    height: 563,
  },
  {
    src: cloudinaryImage('v1752425963/exify-all-metadata-example_vzg4z0.png'),
    alt: 'All metadata example',
    width: 660,
    height: 711,
  },
  {
    src: cloudinaryImage('v1752425944/exify-settings-example_vtqa5v.png'),
    alt: 'Settings example',
    width: 660,
    height: 711,
  },
];

const DEMO_PHOTOS = [
  {
    src: '/assets/images/demo-photos/bench-and-light.jpg',
    alt: 'Black and white photo of a gallery bench beneath an illuminated wall panel',
    width: 1000,
    height: 667,
  },
  {
    src: '/assets/images/demo-photos/woman-with-phone.jpg',
    alt: 'Black and white street photo of a woman checking her phone between brick archways',
    width: 1000,
    height: 667,
  },
  {
    src: '/assets/images/demo-photos/alley-at-night.jpg',
    alt: 'Night photo of a woman walking down a narrow alley',
    width: 1000,
    height: 563,
  },
  {
    src: '/assets/images/demo-photos/museum-painting.jpg',
    alt: 'Man viewing a framed painting in a museum gallery',
    width: 1000,
    height: 562,
  },
];

export const HomepageDemo = () => (
  <>
    <Show pointer="hover">
      <Section
        width="full"
        spaceAfter="lg"
        title="Hover the images below to trigger the EXIF overlay"
        subtitle="Click the Exify logo in the overlay to view all EXIF metadata and change settings."
      >
        <Grid columns="auto-wide" gap="xl">
          {DEMO_PHOTOS.map((image) => (
            <LazyImage key={image.src} {...image} />
          ))}
        </Grid>
      </Section>
    </Show>

    <Show pointer="touch">
      <Section width="full" spaceAfter="lg" title="Screenshots">
        <Grid columns="auto-wide" gap="lg">
          {SCREENSHOTS.map((image) => (
            <LazyImage key={image.src} {...image} />
          ))}
        </Grid>
      </Section>
    </Show>
  </>
);
